import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { CompsPageComponent } from "src/app/comps-page/comps-page/comps-page.component";
import { CommonModalService } from "src/app/shared/common-modal/common-modal.service";
import { AppState } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { DOCUMENT } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { VAIconRegistryService } from "@va/core-library/icons";

@Component({
  selector: "app-create-comps-table",
  templateUrl: "./create-comps-table.component.html",
  styleUrls: [
    "../../comps-page/comps-year-type-filter/comps-year-type-filter.component.scss",
    "./create-comps-table.component.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CreateCompsTableComponent extends CompsPageComponent {
  constructor(
    route: ActivatedRoute,
    modalService: NzModalService,
    dataService: CompsDataService,
    appService: AppService,
    message: NzMessageService,
    commonModalService: CommonModalService,
    @Inject(DOCUMENT) _document: HTMLDocument,
    public router: Router,
    store: Store<AppState>,
    snackBar: MatSnackBar,
    iconRegistry: VAIconRegistryService,
  ) {
    super(
      route,
      modalService,
      dataService,
      appService,
      message,
      commonModalService,
      _document,
      router,
      store,
      snackBar,
      iconRegistry,
    );
  }

  ngOnInit() {
    this.openedForAddIn = true;
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams && queryParams.redirectto) {
      this.excelWebAppURL = decodeURIComponent(queryParams.redirectto);
    }
    if (
      queryParams &&
      queryParams.tickertype &&
      queryParams.tickertype.toLowerCase() === "b"
    ) {
      this.isTickerTypeBg = true;
    } else {
      this.isTickerTypeBg = false;
    }
    super.ngOnInit();
  }
}
